import { ChildRef } from "../../../../../lib/web/components/child-ref";
import { ChildrenRef } from "../../../../../lib/web/components/children-ref";
import { ClickListener } from "../../../../../lib/web/components/click-listener";
import { Component } from "../../../../../lib/web/components/component";
import { ComponentBase } from "../../../../../lib/web/components/component-base";
import { ApiService } from "../../../services/api.service";
import { DataEventService } from "../../../services/data-event.service";
import { MediaPlayerService } from "../../../services/media-player.service";
import { SessionService } from "../../../services/session.service";
import { IconComponent } from "../../atoms/icon/icon.component";
import { DiscoveryAssistantStep } from "../../pages/discovery-assistant/discovery-assistant.component";

@Component({
    selector: '.o-discovery-assistant-result'
})
export class DiscoveryAssistantResultComponent extends ComponentBase<HTMLElement> implements DiscoveryAssistantStep {
   
    private _assistant: any = null;
    private _interestClusters: any[] = null;
    private _interestCluster: any = null;

    @ChildRef('.o-discovery-assistant-result__clusterDescription')
    private _clusterDescription: HTMLDivElement = null;
    @ChildrenRef(HTMLDivElement, '.o-discovery-assistant-result__clusterContent')
    private _clusterContents: HTMLDivElement[] = null;
    
    public constructor(node: HTMLElement, 
        private _mediaPlayerService: MediaPlayerService, 
        private _dataEventService: DataEventService, 
        private _sessionService: SessionService,
        private _apiService: ApiService) {
        super(node);
    }   

    @ClickListener('.o-discovery-assistant-result__backButton')
    public back(): void {
        window.dispatchEvent(new CustomEvent('discovery-assistant-reset'));
    }

    @ClickListener('.o-discovery-assistant-result__clusterContentPlay')
    public onClickPlay(e: MouseEvent): void {
        this.playContent(this._clusterContents.indexOf((e.currentTarget as HTMLButtonElement).closest('.o-discovery-assistant-result__clusterContent')));
    }

    @ClickListener('.o-discovery-assistant-result__clusterContentFavorite')
    public onClickFavorite(e: MouseEvent): void {
        if (this._sessionService.isSigned) {
            this.setFavorite(this._clusterContents.indexOf((e.currentTarget as HTMLButtonElement).closest('.o-discovery-assistant-result__clusterContent')));
        }
        else {
            this.redirect('/u/sign-in');
        }
    }

    @ClickListener('.o-discovery-assistant-result__accessButton')
    public onAccess(): void {
        this._dataEventService.onboardingRegister(this._interestCluster.id);
        window.location.assign(this._interestCluster.formUrl);
    }

    public onInit(): void {
        super.onInit();

        this._clusterContents.forEach(c => c.classList.remove('o-discovery-assistant-result__clusterContent--show'))
    }

    private setCluster(): void {
        this.checkCluster();
        this._clusterDescription.innerText = this._interestCluster.description;

        const contents: any[] = this.contents;
        
        contents.forEach((content, index) => {
            const clusterContent: HTMLDivElement = this._clusterContents[index];
            clusterContent.classList.add('o-discovery-assistant-result__clusterContent--show');
            clusterContent.querySelector('img').src = content.img;
            clusterContent.querySelector<HTMLDivElement>('.o-discovery-assistant-result__clusterContentTitle').innerText = content.title;
        });
    }

    private checkCluster(): void {        
        const interestClusterId: number = this._assistant.assignments?.find((a: any) => a.key?.toLowerCase() === this._assistant.answers?.join('').toLowerCase())?.cluster;
        const interestCluster = interestClusterId ? this._interestClusters.find(c => c.id === interestClusterId): this._interestClusters[Math.floor(Math.random() * this._interestClusters.length)];
        this._interestCluster = interestCluster;
    }

    private playContent(index: number): void {
        const content: any = this.contents[index];
        if (content) {
            this._mediaPlayerService.loadMedia('brightcove',{
                capsuleId: content.type === 'capsule' ? content.id: null,
                collectionId: content.type === 'collection' ? content.id: null,
                type: 'trailer',
                image: content.img,
                controls: {
                    miniPlayer: 'disable',
                    chromecast: false,
                }              
            });
        }
        this._dataEventService.onboardingStartVideo(this._interestCluster.id, content.trailerId);
    }

    private async setFavorite(index: number): Promise<void> {
        const isFavorite: boolean = this.contents[index].isFavorite;
        if (isFavorite) {
            await this._apiService.delete(`/api/v1/user/favorite/${this.contents[index].id}/capsule`);
            this.contents[index].isFavorite = false;
            this.setFavoriteOption(index);
        }
        else {            
            await this._apiService.post(`/api/v1/user/favorite/${this.contents[index].id}/capsule`);
            this.contents[index].isFavorite = true;
            this.setFavoriteOption(index);
        }
    }

    private setFavoriteOption(index: number): void {
        const isFavorite: boolean = this.contents[index].isFavorite;
        const favoriteButton: HTMLButtonElement = this._clusterContents[index]?.querySelector('.o-discovery-assistant-result__clusterContentFavorite') as HTMLButtonElement;
        if (favoriteButton) {
            if (isFavorite) {
                (favoriteButton.querySelector('.a-icon').componentRef.ref as IconComponent).key = 'heart-filled';
            }
            else {
                (favoriteButton.querySelector('.a-icon').componentRef.ref as IconComponent).key = 'heart';
            }
        }
    }

    public get contents(): any[] {
        return this._interestCluster.content?.slice(0, 3)?.filter((c: any) => !!c.trailerId) || [];
    }

    public enter(assistant: any, interestClusters: any[], mode: string): void {        
        this._assistant = assistant;
        this._interestClusters = interestClusters;
        this.setCluster();
        this._dataEventService.onboardingResult(this.contents.map(c => c.trailerId), this._interestCluster.id);
    }

    public exit(): void {
    }
}